import {
  makeStyles, shorthands, tokens,
} from '@fluentui/react-components';

export const useThemeGridStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    ...shorthands.gap(tokens.spacingHorizontalSNudge),
  },
  cell: {
    boxSizing: 'border-box',
    width: '256px',
    height: '160px',
    ...shorthands.padding(tokens.spacingVerticalSNudge),
  },
});
